import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export var switchTab = normalize.switchTab(function (options) {
  my.switchTab(options);
}, CONTAINER_NAME.ALIPAY);
export default switchTab;